import { render, staticRenderFns } from "./PrivateSector.vue?vue&type=template&id=476b1550&scoped=true&"
import script from "./PrivateSector.vue?vue&type=script&lang=js&"
export * from "./PrivateSector.vue?vue&type=script&lang=js&"
import style0 from "./PrivateSector.vue?vue&type=style&index=0&id=476b1550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b1550",
  null
  
)

export default component.exports